// extracted by mini-css-extract-plugin
export default {"header":"styles_header__39G3+","logo":"styles_logo__xx7a-","menu":"styles_menu__zwaJb"};